export const testPassword = (password) => {
  let notAllowed = '!#$%^&*()+{}:"<>?-=[];\'/'
  if(password.length<5 || password.length>100)return false
  if(password.split('').some(c => notAllowed.includes(c))){
    return false
  }
  return true
}
